<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>菜单管理</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加菜单</el-button>
			<!--<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			<el-button class="titBtn" type="success" icon="el-icon-search" @click="query">搜索</el-button>
			<el-input class="querys" v-model.trim="name" placeholder="菜单名称"></el-input>-->
		</div>

		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" @row-click="rowClick" highlight-current-row border row-key="id" :tree-props="{children: 'children'}" :header-cell-style="{background:'rgba(49,130,222,0.1)'}">

				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
				<el-table-column prop="name" label="菜单名称"></el-table-column>
				<el-table-column prop="url" label="链接地址" align="center"></el-table-column>
				<el-table-column prop="perms" label="权限标识" align="center"></el-table-column>
				<!--<el-table-column prop="note" label="描述信息" align="center"></el-table-column>
				<el-table-column prop="zoom" label="页面类型" align="center"></el-table-column>-->
				<el-table-column prop="type" label="类型" align="center">
					<template slot-scope="scope">
						<p v-if="scope.row.type=='0'">目录</p>
						<p v-if="scope.row.type=='1'">菜单</p>
						<p v-if="scope.row.type=='2'">按钮</p>
					</template>

				</el-table-column>
				<el-table-column prop="orderNum" label="排序" align="center"></el-table-column>

				<el-table-column prop="" label="操作" width="90" align="center">
					<template slot-scope="scope">
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<menupopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata"></menupopup>

	</div>
</template>

<script>
	import menupopup from "./popup/menupopup.vue";
	import { menulist ,menudelete} from "@/api/api";
	
	
	
	export default {
		data() {
			return {
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 0, //当前页
				pageNums: null,
				username: '',
				name: '',
				dialogVisible: false,
				Addsid: [],
				row:null,
			}
		},
		components: {

			menupopup
		},
		mounted() {
			this.list();
			
		
		},
		methods: {
			// list(){
			// 	menulist({}).then((res)=>{	
			// 		this.tabledata = res.data;
			// 		this.sortTableData(); // 添加排序逻辑
			// 	})
				
			// },
			
			// sortTableData() {
			// 	this.tabledata.sort((a, b) => {
			// 	return a.orderNum - b.orderNum; // 按照orderNum从小到大排序
			// 	});
			// },

			list() {
				menulist({}).then((res) => {
				this.tabledata = res.data;
				this.sortChildren(this.tabledata); // 添加排序逻辑
				
				});
			},

			sortChildren(data) {
				data.sort((a, b) => {
				return a.orderNum - b.orderNum; // 按照orderNum从小到大排序
				});

				data.forEach((item) => {
				if (item.children && item.children.length > 0) {
					this.sortChildren(item.children); // 递归排序子节点
				}
				});
			},
			
			addClick() {
				this.dialogVisible = true;
				this.Addsid = ["xz"];
			},
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			Adddata(data) {
				this.dialogVisible = data.dialogVisible;
				this.list();
			},
			rowClick(row) {
				this.row = row;
			},
			edit(row, index) {
				this.dialogVisible = true;
				this.Addsid = ["bj", row];
			},
			/*query(){
				menulist({name:this.name}).then((res)=>{		
					console.log(res)
					this.tabledata = res.data;
				})
			},
			reset(){
				this.menuname = '';
			
				this.list();
			},*/
			deletes(row, index) {
				
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {
						menudelete({id:row.id}).then((res) => {
							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
								this.list();
							} else {
								this.$notify({
									title: "提示",
									message:res.message,
									type: "success",
								});
							}
						});

					}
				}).catch(() => {

				});

			},
		}
	}
</script>

<style scoped>
	@import url('../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}
	
	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;

		font-size: 14px;
	}
</style>